const Wallet = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M17.5 7V7.5H18H21C21.1326 7.5 21.2598 7.55268 21.3536 7.64645C21.4473 7.74021 21.5 7.86739 21.5 8V20C21.5 20.1326 21.4473 20.2598 21.3536 20.3536C21.2598 20.4473 21.1326 20.5 21 20.5H3C2.86739 20.5 2.74021 20.4473 2.64645 20.3536C2.55268 20.2598 2.5 20.1326 2.5 20V4C2.5 3.86739 2.55268 3.74021 2.64645 3.64645C2.74021 3.55268 2.86739 3.5 3 3.5H17.5V7ZM4 8.5H3.5V9V19V19.5H4H20H20.5V19V9V8.5H20H4ZM4 4.5H3.5V5V7V7.5H4H16H16.5V7V5V4.5H16H4ZM17.5 13.5V14.5H15.5V13.5H17.5Z"
        stroke={color}
      />
    </svg>
  )
}

export default Wallet
